

/// <reference path="IntegratorSyncEntityQueue.ts" />

// Generated class IntegratorSAPStockNoteLineQueue_ManagedObject

class IntegratorSAPStockNoteLineQueue_ManagedObject extends IntegratorSyncEntityQueue
{
}
